<div class="sync-fusion-main-container">
    <app-header-content-help-text Heading="Replenishment Plan" (printClicked)="handleHeaderPrintClick()"
        [showFilterButton]="showFilter" [showCreateReplenishmentBtn]="showCreateReplenishmentBtn"
        [showPrintReplenishmentBtn]="showPrintReplenishmentBtn"
        (filterButtonClicked)="toggleFilterOverlay()"></app-header-content-help-text>
    <div *ngIf="generatedDate" class="fs-hint-text flex-end fs-margin-0-1"><span>Reports are generated as on
            <strong>{{generatedDate |date}}</strong></span></div>
    <div *ngIf="reportLabelText" class="fs-hint-text flex-end fs-margin-0-1"><span>** {{reportLabelText}}</span></div>
    <ng-container *ngIf="tableDataFetched && appliedFilters">
        <app-filter-bay-reusable *ngIf="appliedFilters" [addFilters]="appliedFilters"></app-filter-bay-reusable>
    </ng-container>
    <mat-tab-group class="custom-tab-group" [selectedIndex]="selectedTabIndex"
        (selectedIndexChange)="tabChanged($event)">
        <mat-tab *ngFor="let tab of tabList; let i = index" [label]="tab.label"
            [class.mat-elevation-z8]="selectedTabIndex === i">
            <ng-template matTabContent>
                <div *ngIf="selectedTabIndex === i" class="store-tabs-container">
                    <ng-container *ngIf="!tableDataFetched; else dataContent">
                        <div class="loader-container">
                            <ng-container *ngFor="let number of [0, 1, 2, 4, 5]">
                                <div class="loader-blocks">
                                    <p class="flowsmart-placeholder">
                                    </p>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                    <ng-template #dataContent>
                        <div *ngIf="dynamic_headers?.length > 0" class="grid-tabs-container">
                            <app-grid-reusable-molecule #gridRef *ngIf="tableDataFetched" [reportName]="reportName"
                                [dynamic_headers]="dynamic_headers" [count]="count" [data]="data"
                                [freezeColumns]="2"></app-grid-reusable-molecule>
                        </div>
                        <app-reusable-filter-molecule #childFilter *ngIf="filterData"
                            [showFiltersPopup]="showFiltersPopup" [reportName]="reportName" [filterData]="filterData"
                            (filterPopupClosed)="showFiltersPopup = $event"
                            (filtersApplied)="handleFilterOutput($event)"
                            (displayFilters)="selectedFilters($event)"></app-reusable-filter-molecule>
                    </ng-template>
                </div>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</div>